import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { VatValidationModel } from '@railmybox/api-user';
import { Observable } from 'rxjs';
import { AbstractValueAccessorComponent, ValueAccessorUtil } from '@railmybox/shared/util';
import { vatRegexValidator } from './validator/vat-input.validator';

interface VatValue {
  vatCountryCode: string;
  vatId: string;
}

@UntilDestroy()
@Component({
  selector: 'rmb-vat-input',
  templateUrl: './vat-input.component.html',
  styleUrls: ['./vat-input.component.scss'],
  providers: [...ValueAccessorUtil.getValueAccessorProvider(VatInputComponent)],
  standalone: false,
})
export class VatInputComponent extends AbstractValueAccessorComponent<string | VatValue> implements OnInit {
  vat$: Observable<VatValidationModel>;

  ngOnInit() {
    const control = this.control;
    if (control) {
      control.setValidators([Validators.required, vatRegexValidator()]);
    }
  }

  patchForm(value: string): void {
    this.formControl.patchValue(value);
  }

  async writeValue(value: string | VatValue): Promise<void> {
    if (!value) {
      return;
    }

    if (typeof value === 'object') {
      super.writeValue(value?.vatCountryCode + value?.vatId);
      return;
    }
    super.writeValue(value);
  }

  inputChanged(value: string): void {
    const vat = { vatCountryCode: value.substring(0, 2).toUpperCase(), vatId: value.substring(2) };
    this.onChange(vat);
    this.formControl?.setValue(vat);
    this.changed.emit(vat);
  }
}
